import React from 'react';
import { useSelector } from 'react-redux';

import SectionHeading from 'components/SectionHeading';

/**
 * Үйл ажиллагааны товчоон — нүүр хуудасны section.
 * Бичлэг бүр: гарчиг → тайлбар → YouTube тоглуулагч.
 * Дизайн нь бусад dark section-уудтай (EPC, мэдээ) ижил.
 */
export default function ActivitySummarySection({ items = [] }) {
    const lang = useSelector((s) => s.system.lang || 'mn');

    if (!items || items.length === 0) return null;

    return (
        <section className="py-20 lg:py-28 bg-brand-dark">
            <div className="max-w-[1440px] mx-auto px-4 lg:px-8">
                <SectionHeading
                    variant="dark"
                    eyebrow={lang === 'en' ? 'Activity' : 'Үйл ажиллагаа'}
                    title={
                        lang === 'en'
                            ? 'Activity Highlights'
                            : 'Үйл ажиллагааны товчоон'
                    }
                />

                <div className="max-w-3xl mx-auto space-y-8">
                    {items.map((item) => {
                        const title =
                            lang === 'en' && item.titleEn
                                ? item.titleEn
                                : item.title;
                        const description =
                            lang === 'en' && item.descriptionEn
                                ? item.descriptionEn
                                : item.description;
                        return (
                            <article
                                key={item.id}
                                className="bg-brand-dark-lighter border-l-4 border-brand-yellow overflow-hidden flex flex-col"
                            >
                                {/* Гарчиг + тайлбар */}
                                {(title || description) && (
                                    <div className="p-6 lg:p-7">
                                        {title && (
                                            <h3 className="font-heading uppercase font-bold text-white text-xl lg:text-2xl leading-tight tracking-tight">
                                                {title}
                                            </h3>
                                        )}
                                        {description && (
                                            <p className="text-white/70 text-sm lg:text-base leading-relaxed mt-3 whitespace-pre-line">
                                                {description}
                                            </p>
                                        )}
                                    </div>
                                )}

                                {/* YouTube тоглуулагч */}
                                {item.embedUrl && (
                                    <div className="relative w-full aspect-video bg-black mt-auto">
                                        <iframe
                                            src={item.embedUrl}
                                            title={title || 'YouTube video'}
                                            className="absolute inset-0 w-full h-full"
                                            loading="lazy"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            allowFullScreen
                                        />
                                    </div>
                                )}
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}